import { Subscription } from 'rxjs';

import { SharedSolaceStreamService } from 'src/solace';

export class IndexRow {
  name: string;
  lastValue: number;
  unitChange: number;
  percentageChange: number;
  volume: number;
  closeValue: number;

  private consumerId = 'index';
  private marketName = 'indexes';
  private indexSubscription: Subscription;

  constructor(
    private sharedSolaceStreamService: SharedSolaceStreamService,
    private index: string,
  ) {
    const marketObservable$: any =
      this.sharedSolaceStreamService.getObservableSymbol(
        this.marketName,
        index,
        this.consumerId,
      );

    const lastIndex: any = this.sharedSolaceStreamService.getMarketElement(
      'indexes',
      index,
    );

    this.setCurrentValues(lastIndex);

    this.indexSubscription = marketObservable$.subscribe(
      (indexShadowed: any) => {
        this.setCurrentValues(indexShadowed);
      },
    );
  }

  dispose(): any {
    if (this.indexSubscription) {
      this.indexSubscription.unsubscribe();
      this.sharedSolaceStreamService.removeConsumerFromObservable(
        this.name,
        this.marketName,
        this.consumerId,
      );
    }
  }

  private setCurrentValues(
    index = {
      name: '',
      lastValue: 0,
      unitChange: 0,
      percentageChange: 0,
      volume: 0,
      closeValue: 0,
    },
  ) {
    this.name = index.name;
    this.lastValue = index.lastValue;
    this.unitChange = index.unitChange;
    this.percentageChange = index.percentageChange;
    this.volume = index.volume;
    this.closeValue = index.closeValue;
  }
}
